<template>
  <div
    v-if="tag"
    class="flex flex-wrap items-center justify-between gap-2 text-base max-sm:text-sm md:justify-start"
  >
    <template v-if="tag">
      <span
        v-if="salary && salaryUnit"
        class="tag"
      >{{ salary }} per {{ salaryUnit }}</span>
      <span
        v-if="vacancy?.city"
        class="tag"
      >{{ vacancy.city }}</span>
      <span
        v-if="vacancy?.hours_per_week"
        class="tag"
      >{{ vacancy.hours_per_week }} uur</span>
    </template>
  </div>
  <div
    v-else
    class="flex flex-wrap justify-between gap-2 text-lg max-lg:flex-col max-sm:text-sm md:justify-start md:gap-x-10 lg:items-center"
  >
    <span
      v-if="salary && salaryUnit"
      class="flex items-center gap-2"
    >
      <span class="text-[10px]">▶</span>
      {{ salary }} per {{ salaryUnit }}
    </span>
    <span
      v-if="vacancy?.city"
      class="flex items-center gap-2"
    >
      <span class="text-[10px]">▶</span>
      {{ vacancy.city }}
    </span>
    <span
      v-if="vacancy?.hours_per_week"
      class="flex items-center gap-2"
    >
      <span class="text-[10px]">▶</span>
      {{ vacancy.hours_per_week }} uur
    </span>
  </div>
</template>

<script setup lang="ts">
import type {Vacancy} from '~/graphql/graphql';
const props = defineProps<{
  tag?: boolean
  vacancy?: Vacancy
}>();

const salaryUnit = computed(() => props.vacancy?.salary_unit ? props.vacancy?.salary_unit.replace(/hour/i, 'uur').replace(/month/i, 'maand') : null);

const salary = computed(() => {
  return '€' + (props.vacancy?.salary + (props.vacancy?.salary_max ? (' - €' + props.vacancy.salary_max) : '')).replace('.', ',');
});
</script>
